import React from 'react';
import PropTypes from 'prop-types';

import CybsPagination from '@cybs-ui/components/lib/pagination';
import { StructFlex } from '@cybs-ui/components/lib/struct-flex';

import BaseTableComponent from '../../components/BaseTableComponent';
import baseStyles from '../../styles/base.styles';
import { GridComponents } from '../../components';

const DISPLAY_NAME = 'BaseTablePagination';

export default class BaseTableFooter extends BaseTableComponent {
  constructor(props) {
    super({
      ...props,
      childDisplayName: DISPLAY_NAME
    });
  }

  shouldRenderPagination = () => {
    const {
      hidePagination,
      variant,
      page,
      pageSize,
      allRowsLength
    } = this.props;
    const isValidVariant = variant === 'settings' || variant === 'display';
    const hasProps = page && pageSize && page > -1 && pageSize > -1;

    return !hidePagination && isValidVariant && hasProps && pageSize < allRowsLength;
  };

  renderLeftSide = () => {
    const {
      dataTest: dataTestProp,
      leftFooter,
      onFooterClick,
      tableId
    } = this.props;
    let buttons = [];
    if (leftFooter && Array.isArray(leftFooter) && leftFooter.length > 0) {
      buttons = leftFooter.map(({ id, options }) => {
        const dataTest = `${tableId}-${dataTestProp}-footer-${options.label}`;
        return (
          <div css={theme => baseStyles.footerStyles(theme).leftButtonContainer}>
            <GridComponents.Button
              {...options}
              i18n={{ label: options.label }}
              onClick={() => onFooterClick(id)}
              dataTest={dataTest}
              colorScheme="secondary"
              iconLocation="left"
            />
          </div>
        );
      });
    }
    return (
      <StructFlex
        css={theme => baseStyles.footerStyles(theme).leftContainer}
        id={`${tableId}-left-footer-container`}
        direction="row"
        wrap="wrap"
      >
        {buttons}
      </StructFlex>
    );
  };

  renderPagination = () => {
    const {
      allRowsLength,
      dataTest,
      isControlledPagination,
      page,
      pageSize,
      onPageChange,
      tableId,
      styles,
      i18n,
      jumpToLast,
      pagesToShow,
      totalPages: totalPagesProp
    } = this.props;
    const totalPages = isControlledPagination
      ? totalPagesProp
      : Math.ceil(allRowsLength / pageSize);
    return (this.shouldRenderPagination() || isControlledPagination)? (
      <div
        id={`${tableId}-paginationWrapper`}
        css={styles ? styles.paginationWrapper : null}
      >
        <CybsPagination
          i18n={i18n}
          dataTest={`${tableId}-${dataTest}-pagination`}
          selectedPage={page}
          pagesToShow={pagesToShow}
          onChange={(e, newPage) => onPageChange(newPage)}
          onButtonClick={(e, newPage) => onPageChange(newPage)}
          totalPages={totalPages}
          jumpToLast={jumpToLast}
        />
      </div>
    ) : null;
  };

  render() {
    const { tableId } = this.props;
    const footerId = `${tableId}-footer-container`;
    return (
      <StructFlex
        id={footerId}
        direction="row"
        wrap="wrap"
      >
        {this.renderLeftSide()}
        {this.renderPagination()}
      </StructFlex>
    );
  }
}

BaseTableFooter.propTypes = {
  /**
   * Used to calculate number of pages. All of rows not displayed rows
   */
  allRowsLength: PropTypes.number.isRequired,
  /**
   * Callback for updating page change
   */
  onPageChange: PropTypes.func.isRequired,
  /**
   * Current page
   */
  page: PropTypes.number.isRequired,
  /**
   * Page size of gridtable defined in config
   */
  pageSize: PropTypes.number.isRequired,
  /**
   * Table Id of parent table
   */
  tableId: PropTypes.string.isRequired
};
BaseTableFooter.defaultProps = {};
